import React, { memo } from 'react';
import { Loader2 } from 'lucide-react';
import { clsx } from 'clsx';
import type { LoadingSpinnerProps } from '../types/interfaces';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = memo(({
  size = 'md',
  className = '',
  text = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={clsx('flex items-center justify-center gap-2', className)}>
      <Loader2 
        className={clsx('animate-spin', sizeClasses[size])}
        aria-hidden="true"
      />
      {text && (
        <span className={clsx('text-brand-gray-600', textSizeClasses[size])}>
          {text}
        </span>
      )}
    </div>
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;